import { Navigate, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import RequestResetPage from '@/auth/RequestPasswordResetPage'
import ResetPasswordPage from '@/auth/ResetPasswordPage'

import { AuthProvider } from '@/services/authentication.service'

import ProviderLayout from './_Layout'
import ProviderDashboard from './ProviderDashboard'
import ProviderFamilies from './ProviderFamilies'
import ProviderFamilyDetail from './ProviderFamilyDetail'
import ProviderFormerPatient from './ProviderFormerPatient'
import ProviderFamilyHomework from './ProviderFamilyHomework'
import ProviderFamilyRoadmap from './ProviderFamilyRoadmap'
import ProviderLicenses from './ProviderLicenses'
import ProviderLogin from './ProviderLogin'
import ProviderRoadmapReviews from './ProviderRoadmapReviews'
import { ProviderAuthWrapper } from './ProviderSession'
import ProviderSettings from './ProviderSettings'
import ProviderTeam from './ProviderTeam'
import ProviderTeamMemberDetail from './ProviderTeamMemberDetail'

// The coordinator portal. Rendered instead of the family app when the site is
// served from the provider. host (see index.tsx) — family and admin routes are
// not registered on that host at all.
export default function ProviderApp() {
    return (
        <AuthProvider>
            <Routes>
                <Route path='/login' element={<ProviderLogin />} />
                <Route path='/request-reset' element={<RequestResetPage portal='provider' />} />
                <Route path='/reset-password' element={<ResetPasswordPage portal='provider' />} />
                <Route element={<ProviderAuthWrapper />}>
                    <Route path='/' element={<ProviderLayout />}>
                        <Route index element={<Navigate to='/dashboard' replace />} />
                        <Route path='dashboard' element={<ProviderDashboard />} />
                        <Route path='team' element={<ProviderTeam />} />
                        <Route path='team/former/:id' element={<ProviderTeamMemberDetail former />} />
                        <Route path='team/:id' element={<ProviderTeamMemberDetail />} />
                        <Route path='licenses' element={<ProviderLicenses />} />
                        <Route path='clients' element={<ProviderFamilies />} />
                        <Route path='roadmap-reviews' element={<ProviderRoadmapReviews />} />
                        <Route path='clients/former/:id' element={<ProviderFormerPatient />} />
                        <Route path='clients/:id' element={<ProviderFamilyDetail />} />
                        <Route path='clients/:id/roadmap' element={<ProviderFamilyRoadmap />} />
                        <Route path='clients/:id/homework' element={<ProviderFamilyHomework />} />
                        <Route path='settings' element={<ProviderSettings />} />
                        <Route path='*' element={<Navigate to='/dashboard' replace />} />
                    </Route>
                </Route>
            </Routes>
            <ToastContainer position='top-center' autoClose={1000} />
        </AuthProvider>
    )
}
